import * as Yup from 'yup';

export const validationSchema = Yup.object({
  organizationId: Yup.string().required('Organization name is required'),
});